import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { notification } from 'antd';
import * as Yup from 'yup';
import { Form, Formik, FormikHelpers } from 'formik';
import Button from 'components/Button';
import TextField from 'components/Forms/TextField';
import Descriptions from 'components/Descriptions';
import SelectField from 'components/Forms/SelectField';
import { addUpdateCustomerWireTransferSettings } from 'services/api';
import { RoutingNumberRegex, BankAccountNumberRegex } from 'config';
import { StyledModal } from './styles';

interface AddWireTransferDetailModalProps {
  customerId: string;
  customerPk: number;
  onClose: () => void;
}

interface FormType {
  bankName: string;
  accountHolder: string;
  accountType: string;
  routingNumber: string;
  accountNumber: string;
  confirmAccountNumber: string;
}

const Schema = Yup.object().shape({
  bankName: Yup.string().required('Required'),
  accountHolder: Yup.string().required('Required'),
  accountType: Yup.string().nullable().required('Required'),
  confirmAccountNumber: Yup.string()
    .required('Required.')
    .test(
      'password-match-validation',
      'Account number does not match.',
      (value, context) => context.parent.accountNumber === value,
    ),
  accountNumber: Yup.string()
    .required('Required')
    .matches(BankAccountNumberRegex, 'Invalid'),
  routingNumber: Yup.string()
    .required('Required')
    .matches(RoutingNumberRegex, 'Invalid'),
});

const BankTypeOptions = [
  {
    value: 'checking',
    label: 'Checking',
  },
  {
    value: 'savings',
    label: 'Savings',
  },
];

const AddWireTransferDetailModal = NiceModal.create(
  ({ customerId, customerPk, onClose }: AddWireTransferDetailModalProps) => {
    const modal = useModal();
    console.log(customerId, customerPk);

    const onSubmit = async (
      values: FormType,
      { setSubmitting }: FormikHelpers<FormType>,
    ) => {
      setSubmitting(true);
      try {
        const payload = {
          customer_pk: customerPk,
          institution_name: values.bankName,
          account_holder_name: values.accountHolder,
          account_type: values.accountType,
          bank_account_number: values.accountNumber,
          routing_number: values.routingNumber,
        };
        await addUpdateCustomerWireTransferSettings(payload);
        onClose();
        modal.hide();

        notification.success({
          message: 'Success',
          description: 'Added Customer Wire Transfer Details successfully',
        });
      } catch (error) {
        // let description = 'Add Bank Account failed';
        // if (get(error, 'data.message') === 'Routing number is invalid.') {
        //   description = 'Routing number is invalid.';
        // }
        // errorNotification(error, description);
      }
    };

    return (
      <StyledModal
        title="Add Wire Transfer Detail"
        onCancel={() => modal.hide()}
        width={500}
        footer={null}
        destroyOnClose={true}
      >
        <Formik
          initialValues={
            {
              bankName: '',
              accountHolder: '',
              accountType: 'checking',
              routingNumber: '',
              accountNumber: '',
              confirmAccountNumber: '',
            } as FormType
          }
          onSubmit={onSubmit}
          validationSchema={Schema}
        >
          {() => {
            return (
              <Form>
                <div className="form-wrapper">
                  <div className="col-wrapper">
                    <div className="table-wrapper">
                      <Descriptions fullWidth>
                        <TextField
                          label="Bank Name"
                          name="bankName"
                          placeholder="Bank Name"
                        />
                        <TextField
                          label="Account Holder"
                          name="accountHolder"
                          placeholder="Account Holder"
                        />
                        <SelectField
                          label="Account Type"
                          options={BankTypeOptions}
                          name="accountType"
                          placeholder="Checking"
                        />
                        <TextField
                          label="Wire Routing Number"
                          name="routingNumber"
                          placeholder="222222226"
                        />
                        <TextField
                          label="Account #"
                          name="accountNumber"
                          placeholder="123456789"
                        />
                        <TextField
                          label="Confirm Account #"
                          name="confirmAccountNumber"
                          placeholder="123456789"
                        />
                      </Descriptions>
                    </div>
                  </div>
                </div>
                <div className="ant-modal-footer">
                  <div className="button-wrapper">
                    <Button htmlType="submit">Submit</Button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </StyledModal>
    );
  },
);

export default AddWireTransferDetailModal;
